import useAuth from './useAuth';

const useMe = () => {
  const { me } = useAuth();
  return me;
};

export default useMe;
